import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=865af4fc&scoped=true"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"
import style0 from "./AdBanner.vue?vue&type=style&index=0&id=865af4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865af4fc",
  null
  
)

export default component.exports